import LAYOUT from '@/layouts/default/index.vue';

export default {
  path: '/driveExperience',
  component: LAYOUT,
  name: 'DriveExperience',
  redirect: '/driveExperience/index',
  meta: {
    title: '试驾体验营',
  },
  children: [
    {
      path: 'index',
      name: 'DriveExperienceIndex',
      meta: {
        title: '试驾体验营',
      },
      component: () => import('@/views/driveExperience/index'),
    },
    {
      path: 'success',
      name: 'DriveExperienceSuccess',
      meta: {
        title: '试驾体验营',
      },
      component: () => import('@/views/driveExperience/success'),
    },
  ],
};
